import React from "react";
import { Container, FooterBottom } from "./styles.js";

function Footer({ hidden }) {
  return (
    <Container hidden={hidden}>
      <FooterBottom>
        <span>Moov PRO | {new Date().getFullYear()}</span>
        <small>V 1.12.4</small>
        <small>04/02/2026 - 11:52</small>
      </FooterBottom>
    </Container>
  );
}

export default Footer;
